<template>
  <div class="dimensions">
    <span class="length">{{ size.length }}mm</span>
    <span class="width">{{ size.width }}mm</span>
    <span class="height">{{ size.height }}mm</span>
    <img :src="getImage('powerpack-image/dimensionsPP.png')">
  </div>
</template>

<script>
import orderMixin from "../../mixins/orderMixin";
import {mapGetters, mapState} from "vuex";
import getBuildMixin from "../../mixins/getBuildMixin";

export default {
  name: "PowerpackDimension",

  mixins: [getBuildMixin],

  computed: {
    ...mapGetters({
      motorOption: 'build/getMotorOption',
      openFrameOptions: 'openFrameOptions/getAll',
    }),
    size() {
      let support = this.powerpackOptions.find(option => option.type === 'support');

      let size = {
        width: 0,
        height: 0,
        length: 0,
      };

      let baseHeight = 0;
      let motorHeight = 0;
      let tankHeight = 0;
      let valveHeight = 0;

      if (this.motor) {
        this.setWidth(size, this.motor);
        size.length += this.motor.length;
        motorHeight += this.motor.height;
      }
      if (this.pump) {
        this.setWidth(size, this.pump);
      }
      if (this.tank) {
        this.setWidth(size, this.tank);
        size.length += this.tank.length;
        tankHeight += this.tank.height;
      }

      if (this.circuit) {
        this.setWidth(size, this.circuit);
        size.length += this.circuit.length;
        baseHeight += this.circuit.height;
      }

      // Valves
      if (this.valves.length && (this.motorOption !== 'open_frame' || this.motorOption !== 'closed_frame')) {
        let a01 = this.powerpackOptions.find(option => option.type === 'A01');
        let a03 = this.powerpackOptions.find(option => option.type === 'A03');

        valveHeight += a01.height;

        for (const v of this.valves) {
          valveHeight += a03.height;

          this.setWidth(size, v);
          if (!v.additionalValves) continue;
          for (const av of v.additionalValves) {
            this.setWidth(size, av);
          }
        }
      } else {
        for (const valve of this.valves) {
          this.setWidth(size, valve);
        }
      }

      let bottomHeight = 0;
      if (support && support.selected === true && this.motorOption !== 'open_frame') {
        this.setWidth(size, support);
        bottomHeight += support.height;
      } else {
        bottomHeight += Math.max(motorHeight, tankHeight);
      }

      let topHeight = 0;
      topHeight += Math.max(motorHeight, tankHeight, valveHeight);

      size.height += bottomHeight;
      size.height += baseHeight;
      size.height += topHeight;


      for (const option of this.openFrameOptions) {
        if (option.selected) {
          this.setWidth(size, option);
          size.length = option.length > size.length ? option.length : size.length;
          size.height = option.height > size.height ? option.height : size.height;
        }
      }

      return size;
    },
  },

  methods: {
    setWidth(size, {width, height, length}) {
      if (width > size.width) size.width = width;
    }
  }
}
</script>

<style scoped lang="scss">
.dimensions {
  position: absolute;
  bottom: 0;
  right: 0;
  min-height: 100px;
  min-width: 100px;

  @media only screen and (max-width: 768px) {
    transform: scale(0.8);
  }

  span {
    font-size: 12px;
    font-weight: bold;
    position: absolute;

    &.height {
      top: 5px;
      right: 25px;
    }

    &.width {
      right: 0;
      bottom: 0;
    }

    &.length {
      bottom: 0;
      left: 0;
    }
  }

  img {
    display: block;
    position: absolute;
    margin: auto;
    max-width: 100%;
    padding: 20px;
  }
}
</style>
